import { combineReducers } from '@reduxjs/toolkit'

import { reducer as notification } from './notification'
import { reducer as app } from './app'

export default combineReducers({ notification, app })
